import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Grid,
  Stack,
  Typography,
  useTheme,
} from '@mui/material';
import Chart from 'react-apexcharts';
import { ApexOptions } from 'apexcharts';

const useChartOptions = (labels: any): ApexOptions => {
  const theme = useTheme();

  return {
    chart: {
      background: 'transparent',
    },
    colors: [theme.palette.primary.main, theme.palette.error.main],
    dataLabels: {
      enabled: false,
    },
    labels,
    legend: {
      show: false,
    },
    plotOptions: {
      pie: {
        expandOnClick: false,
      },
    },
    states: {
      active: {
        filter: {
          type: 'none',
        },
      },
      hover: {
        filter: {
          type: 'none',
        },
      },
    },
    stroke: {
      width: 0,
    },
    theme: {
      mode: theme.palette.mode,
    },
    tooltip: {
      fillSeriesColor: false,
    },
  };
};

export const OverviewExpense = (props: any) => {
  const { chartSeries, labels, sx } = props;
  const chartOptions = useChartOptions(labels);

  return (
    <Card sx={sx}>
      <CardHeader title='Advertise Overview' />
      <CardContent>
        <Grid
          container
          spacing={2}
          sx={{ pt: 3 }}
        >
          <Grid
            item
            xs={12}
            sm={12}
            md={6}
          >
            <Chart
              height={300}
              options={chartOptions}
              series={chartSeries}
              type='donut'
              width='100%'
            />
          </Grid>

          <Grid
            item
            xs={12}
            sm={12}
            md={6}
          >
            <Stack
              alignItems='center'
              direction='column'
              justifyContent='space-evenly'
              spacing={2}
              sx={{ mt: 2, height: '100%' }}
            >
              {chartSeries.map((item: any, index: number) => {
                const label = labels[index];

                return (
                  <Box
                    key={label}
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'stretch',
                    }}
                  >
                    <Typography
                      sx={{ my: 1 }}
                      variant='h6'
                    >
                      {label}
                    </Typography>
                    <Typography
                      color='text.secondary'
                      variant='subtitle1'
                      sx={{
                        display: 'flex',
                        justifyContent: 'center',
                      }}
                    >
                      {item}
                    </Typography>
                  </Box>
                );
              })}
            </Stack>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};
